<script lang="ts">
  let {
    value,
  }: {
    value: unknown
  } = $props()

  const id = $derived(String(value ?? ''))

  async function copyValue(): Promise<void> {
    if (!navigator.clipboard) {
      return
    }

    await navigator.clipboard.writeText(id)
  }
</script>

<span class="widget-id-chip">
  <span>{id}</span>
  <button type="button" aria-label="Copy ID" title="Copy ID" onclick={copyValue}>
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M5 2.5h7.5v8.5H11V4H5V2.5Z" />
      <path d="M3.5 5h7v8.5h-7V5Zm1.5 1.5V12h4V6.5H5Z" />
    </svg>
  </button>
</span>
